export const fakeAssetData = {
  data: [
    {
      id: "bitcoin",
      rank: "1",
      symbol: "BTC",
      name: "Bitcoin",
      supply: "19277125.0000000000000000",
      maxSupply: "21000000.0000000000000000",
      marketCapUsd: "446845007242.7681904860380875",
      volumeUsd24Hr: "12490689053.5412569340541575",
      priceUsd: "23180.0648303503862991",
      changePercent24Hr: "-1.8597422453331545",
      vwap24Hr: "23518.7902059505436786",
      explorer: "https://blockchain.info/",
    },
    {
      id: "ethereum",
      rank: "2",
      symbol: "ETH",
      name: "Ethereum",
      supply: "122373866.2178000000000000",
      maxSupply: null,
      marketCapUsd: "193963678191.0965933235923916",
      volumeUsd24Hr: "4248104054.7657754455943699",
      priceUsd: "1585.0089907748900826",
      changePercent24Hr: "-2.0525556889226873",
      vwap24Hr: "1614.8340255528460036",
      explorer: "https://etherscan.io/",
    },
    {
      id: "tether",
      rank: "3",
      symbol: "USDT",
      name: "Tether",
      supply: "67776034767.7713400000000000",
      maxSupply: null,
      marketCapUsd: "67857014180.7367856124677522",
      volumeUsd24Hr: "18178658176.1195061266486107",
      priceUsd: "1.0011948089504338",
      changePercent24Hr: "-0.0507338488988271",
      vwap24Hr: "1.0004945106196500",
      explorer: "https://www.omniexplorer.info/asset/31",
    },
    {
      id: "binance-coin",
      rank: "4",
      symbol: "BNB",
      name: "BNB",
      supply: "166801148.0000000000000000",
      maxSupply: "166801148.0000000000000000",
      marketCapUsd: "51594750784.4159289256856600",
      volumeUsd24Hr: "249271526.6752972046164941",
      priceUsd: "309.3189189825955450",
      changePercent24Hr: "-2.7053291745818641",
      vwap24Hr: "313.6003072571100162",
      explorer:
        "https://etherscan.io/token/0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
    },
    {
      id: "usd-coin",
      rank: "5",
      symbol: "USDC",
      name: "USD Coin",
      supply: "43022887229.6520800000000000",
      maxSupply: null,
      marketCapUsd: "43053746371.0654395740562583",
      volumeUsd24Hr: "738267929.3162923317900952",
      priceUsd: "1.0007172726750912",
      changePercent24Hr: "-0.2400572646892562",
      vwap24Hr: "1.0005197468998742",
      explorer:
        "https://etherscan.io/token/0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    },
    {
      id: "xrp",
      rank: "6",
      symbol: "XRP",
      name: "XRP",
      supply: "45404028640.0000000000000000",
      maxSupply: "100000000000.0000000000000000",
      marketCapUsd: "18173817487.6819264683258080",
      volumeUsd24Hr: "488801834.5492610461796295",
      priceUsd: "0.4002688314682097",
      changePercent24Hr: "-3.1669501914932898",
      vwap24Hr: "0.4088916255139489",
      explorer: "https://xrpcharts.ripple.com/#/graph/",
    },
    {
      id: "binance-usd",
      rank: "7",
      symbol: "BUSD",
      name: "Binance USD",
      supply: "15704383591.1333750000000000",
      maxSupply: null,
      marketCapUsd: "15722624537.8087776282599132",
      volumeUsd24Hr: "1218400625.8136728819124595",
      priceUsd: "1.0011615194298808",
      changePercent24Hr: "-0.0250990498579143",
      vwap24Hr: "1.0011425356302898",
      explorer:
        "https://etherscan.io/token/0x4Fabb145d64652a948d72533023f6E7A623C7C53",
    },
    {
      id: "cardano",
      rank: "8",
      symbol: "ADA",
      name: "Cardano",
      supply: "34593679000.3860000000000000",
      maxSupply: "45000000000.0000000000000000",
      marketCapUsd: "13175792780.0405152020268401",
      volumeUsd24Hr: "152716017.6305204378292561",
      priceUsd: "0.3808728403791195",
      changePercent24Hr: "-2.9263965578022160",
      vwap24Hr: "0.3893473606369322",
      explorer: "https://cardanoexplorer.com/",
    },
    {
      id: "dogecoin",
      rank: "9",
      symbol: "DOGE",
      name: "Dogecoin",
      supply: "132670764299.8940900000000000",
      maxSupply: null,
      marketCapUsd: "11496357118.4635898964453592",
      volumeUsd24Hr: "224140048.6182938502743126",
      priceUsd: "0.0866532817469626",
      changePercent24Hr: "-3.2403669437945733",
      vwap24Hr: "0.0883719615422757",
      explorer: "http://dogechain.info/chain/Dogecoin",
    },
    {
      id: "polygon",
      rank: "10",
      symbol: "MATIC",
      name: "Polygon",
      supply: "8734317475.2849300000000000",
      maxSupply: "10000000000.0000000000000000",
      marketCapUsd: "9758215331.2794882381452320",
      volumeUsd24Hr: "246220273.4836961409937895",
      priceUsd: "1.1172270024408698",
      changePercent24Hr: "-5.5199629835301607",
      vwap24Hr: "1.1491414427587169",
      explorer:
        "https://etherscan.io/token/0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
    },
    {
      id: "solana",
      rank: "11",
      symbol: "SOL",
      name: "Solana",
      supply: "371657569.1629921000000000",
      maxSupply: null,
      marketCapUsd: "9056659591.4586459220901435",
      volumeUsd24Hr: "408556227.3492281857329246",
      priceUsd: "24.3682904450327691",
      changePercent24Hr: "-1.9743312595137427",
      vwap24Hr: "25.5116241657799186",
      explorer: "https://explorer.solana.com/",
    },
    {
      id: "polkadot",
      rank: "12",
      symbol: "DOT",
      name: "Polkadot",
      supply: "1197514655.6665600000000000",
      maxSupply: null,
      marketCapUsd: "7531723190.6067856599228089",
      volumeUsd24Hr: "97922527.3495237390172449",
      priceUsd: "6.2894622249232363",
      changePercent24Hr: "-4.1686926735783588",
      vwap24Hr: "6.4867116692957458",
      explorer: "https://polkascan.io/polkadot",
    },
    {
      id: "terra-luna",
      rank: "13",
      symbol: "LUNA",
      name: "Terra",
      supply: "3453685944.3708580000000000",
      maxSupply: null,
      marketCapUsd: "7114808230.4913780785608137",
      volumeUsd24Hr: "13159504.3887972554875212",
      priceUsd: "2.0600623059221008",
      changePercent24Hr: "-4.5115547157443545",
      vwap24Hr: "2.1247831369771654",
      explorer: "https://finder.terra.money/",
    },
    {
      id: "litecoin",
      rank: "14",
      symbol: "LTC",
      name: "Litecoin",
      supply: "72169915.7197621500000000",
      maxSupply: "84000000.0000000000000000",
      marketCapUsd: "6664884525.4229247165052499",
      volumeUsd24Hr: "291880957.6165623693670395",
      priceUsd: "92.3499003560273264",
      changePercent24Hr: "-3.3484480554762132",
      vwap24Hr: "94.4454016793635346",
      explorer: "http://explorer.litecoin.net/chain/Litecoin",
    },
    {
      id: "avalanche",
      rank: "15",
      symbol: "AVAX",
      name: "Avalanche",
      supply: "314805032.6303181600000000",
      maxSupply: "720000000.0000000000000000",
      marketCapUsd: "6581085011.3620986289814027",
      volumeUsd24Hr: "175667516.4694293531476576",
      priceUsd: "20.9052725630673073",
      changePercent24Hr: "1.3638425277928534",
      vwap24Hr: "20.6059411207499782",
      explorer: "https://avascan.info/",
    },
    {
      id: "shiba-inu",
      rank: "16",
      symbol: "SHIB",
      name: "Shiba Inu",
      supply: "549063278876301.9400000000000000",
      maxSupply: null,
      marketCapUsd: "6392364933.8654973744687616",
      volumeUsd24Hr: "116345370.1460215744021811",
      priceUsd: "0.0000116423100575",
      changePercent24Hr: "-3.0000877363092465",
      vwap24Hr: "0.0000118825943431",
      explorer:
        "https://etherscan.io/token/0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
    },
    {
      id: "multi-collateral-dai",
      rank: "17",
      symbol: "DAI",
      name: "Multi Collateral DAI",
      supply: "5830437050.1298780000000000",
      maxSupply: null,
      marketCapUsd: "5832094850.3793346265107063",
      volumeUsd24Hr: "56474104.2617492038938283",
      priceUsd: "1.0002843355026738",
      changePercent24Hr: "-0.1906195604364218",
      vwap24Hr: "0.9997954433875695",
      explorer:
        "https://etherscan.io/token/0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359",
    },
    {
      id: "tron",
      rank: "18",
      symbol: "TRX",
      name: "TRON",
      supply: "91816545566.1427200000000000",
      maxSupply: null,
      marketCapUsd: "5774211048.5955555567489330",
      volumeUsd24Hr: "114903960.6073236124303629",
      priceUsd: "0.0628885677738326",
      changePercent24Hr: "-0.7820816512941294",
      vwap24Hr: "0.0630822653316209",
      explorer: "https://tronscan.org/#/",
    },
    {
      id: "uniswap",
      rank: "19",
      symbol: "UNI",
      name: "Uniswap",
      supply: "762209326.5354977000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "5058586112.2024062975699867",
      volumeUsd24Hr: "50979869.9415588775629427",
      priceUsd: "6.6367412941473857",
      changePercent24Hr: "-4.0227622031696074",
      vwap24Hr: "6.8015821951058671",
      explorer:
        "https://etherscan.io/token/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    },
    {
      id: "wrapped-bitcoin",
      rank: "20",
      symbol: "WBTC",
      name: "Wrapped Bitcoin",
      supply: "176647.6013569400000000",
      maxSupply: null,
      marketCapUsd: "4084519656.8411346083014039",
      volumeUsd24Hr: "122952705.1327997258913153",
      priceUsd: "23122.4178843380882861",
      changePercent24Hr: "-1.9330438105118678",
      vwap24Hr: "23413.7727340878351922",
      explorer:
        "https://etherscan.io/token/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
    },
    {
      id: "chainlink",
      rank: "21",
      symbol: "LINK",
      name: "Chainlink",
      supply: "507999970.4527867000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "3573319086.9038756872312727",
      volumeUsd24Hr: "130761105.7394094700493049",
      priceUsd: "7.0340930998852852",
      changePercent24Hr: "-3.9120641012540878",
      vwap24Hr: "7.2591352528050854",
      explorer:
        "https://etherscan.io/token/0x514910771af9ca656af840dff83e8264ecf986ca",
    },
    {
      id: "unus-sed-leo",
      rank: "22",
      symbol: "LEO",
      name: "UNUS SED LEO",
      supply: "953954130.0000000000000000",
      maxSupply: null,
      marketCapUsd: "3434097400.8889988655927360",
      volumeUsd24Hr: "516102.1886680214190068",
      priceUsd: "3.5998558975671072",
      changePercent24Hr: "-2.1722236267627278",
      vwap24Hr: "3.6423468062604287",
      explorer: "https://eospark.com/account/bitfinexleo1",
    },
    {
      id: "cosmos",
      rank: "23",
      symbol: "ATOM",
      name: "Cosmos",
      supply: "248453201.0000000000000000",
      maxSupply: null,
      marketCapUsd: "3311420824.1949600685055786",
      volumeUsd24Hr: "94529346.7146464599302089",
      priceUsd: "13.3281471555480586",
      changePercent24Hr: "-3.0703799492841137",
      vwap24Hr: "13.6231110295960232",
      explorer: "https://www.mintscan.io/",
    },
    {
      id: "monero",
      rank: "24",
      symbol: "XMR",
      name: "Monero",
      supply: "18233793.3695291900000000",
      maxSupply: null,
      marketCapUsd: "3275484049.3457766652008472",
      volumeUsd24Hr: "41547677.9009738907667822",
      priceUsd: "179.6381028875480824",
      changePercent24Hr: "-3.0457764905793098",
      vwap24Hr: "184.5896604204001308",
      explorer: "http://moneroblocks.info/",
    },
    {
      id: "ethereum-classic",
      rank: "25",
      symbol: "ETC",
      name: "Ethereum Classic",
      supply: "139190588.0580228300000000",
      maxSupply: "210700000.0000000000000000",
      marketCapUsd: "3034802620.1327478708052812",
      volumeUsd24Hr: "83910352.5740720332155165",
      priceUsd: "21.8032171749117369",
      changePercent24Hr: "-2.6120143150760335",
      vwap24Hr: "22.5944463695077966",
      explorer: "http://gastracker.io/",
    },
    {
      id: "bitcoin-cash",
      rank: "26",
      symbol: "BCH",
      name: "Bitcoin Cash",
      supply: "19298162.5000000000000000",
      maxSupply: "21000000.0000000000000000",
      marketCapUsd: "2549392933.0513749774071788",
      volumeUsd24Hr: "51594722.9156379169437761",
      priceUsd: "132.1054754851077131",
      changePercent24Hr: "-3.9114447917262359",
      vwap24Hr: "134.8489962263573065",
      explorer: "https://blockchair.com/bitcoin-cash/blocks",
    },
    {
      id: "stellar",
      rank: "27",
      symbol: "XLM",
      name: "Stellar",
      supply: "26273098632.8479460000000000",
      maxSupply: "50001806812.0000000000000000",
      marketCapUsd: "2409567078.5371408340694789",
      volumeUsd24Hr: "25329506.0217629123400153",
      priceUsd: "0.0917123294899285",
      changePercent24Hr: "-2.1003363191311204",
      vwap24Hr: "0.0930434299181284",
      explorer: "https://dashboard.stellar.org/",
    },
    {
      id: "okb",
      rank: "28",
      symbol: "OKB",
      name: "OKB",
      supply: "60000000.0000000000000000",
      maxSupply: null,
      marketCapUsd: "2274203244.6555304260000000",
      volumeUsd24Hr: "1229985.8679657349774510",
      priceUsd: "37.9033874109255071",
      changePercent24Hr: "-3.9641803029547784",
      vwap24Hr: "38.7967844583000707",
      explorer:
        "https://etherscan.io/token/0x75231f58b43240c9718dd58b4967c5114342a86c",
    },
    {
      id: "near-protocol",
      rank: "29",
      symbol: "NEAR",
      name: "NEAR Protocol",
      supply: "851545428.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "2041557928.5900666652499484",
      volumeUsd24Hr: "51821444.2361441921443896",
      priceUsd: "2.3974738886039403",
      changePercent24Hr: "-6.0850478709140328",
      vwap24Hr: "2.4997039552654566",
      explorer: "https://explorer.nearprotocol.com/",
    },
    {
      id: "crypto-com-coin",
      rank: "30",
      symbol: "CRO",
      name: "Crypto.com Coin",
      supply: "25263013692.0000000000000000",
      maxSupply: "30263013692.0000000000000000",
      marketCapUsd: "1986414054.5931265824118284",
      volumeUsd24Hr: "11814298.6600351655924030",
      priceUsd: "0.0786293384792077",
      changePercent24Hr: "-4.3900531037467443",
      vwap24Hr: "0.0810555310156675",
      explorer:
        "https://etherscan.io/token/0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b",
    },
    {
      id: "filecoin",
      rank: "31",
      symbol: "FIL",
      name: "Filecoin",
      supply: "374176765.0000000000000000",
      maxSupply: null,
      marketCapUsd: "1936735635.2645925651005960",
      volumeUsd24Hr: "86918499.0781510676377736",
      priceUsd: "5.1759911796356264",
      changePercent24Hr: "-3.9292947479300952",
      vwap24Hr: "5.3497649723925944",
      explorer: "https://protocol.ai",
    },
    {
      id: "lido-dao",
      rank: "32",
      symbol: "LDO",
      name: "Lido DAO",
      supply: "837514128.9690621000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "1777514814.8931041845089209",
      volumeUsd24Hr: "9701925.6246533678897730",
      priceUsd: "2.1223699438732285",
      changePercent24Hr: "-7.7847711789212830",
      vwap24Hr: "2.2335918185406420",
      explorer:
        "https://etherscan.io/token/0x5a98fcbea516cf06857215779fd812ca3bef1b32",
    },
    {
      id: "algorand",
      rank: "33",
      symbol: "ALGO",
      name: "Algorand",
      supply: "7199413500.6929500000000000",
      maxSupply: "10000000000.0000000000000000",
      marketCapUsd: "1772572159.4492869094201408",
      volumeUsd24Hr: "35506652.4763705361740821",
      priceUsd: "0.2462106335854546",
      changePercent24Hr: "-5.6560750263599598",
      vwap24Hr: "0.2544906509866390",
      explorer: "https://algoexplorer.io/",
    },
    {
      id: "quant",
      rank: "34",
      symbol: "QNT",
      name: "Quant",
      supply: "12072738.0000000000000000",
      maxSupply: "14612493.0000000000000000",
      marketCapUsd: "1741736352.4843130052847710",
      volumeUsd24Hr: "16959340.9828648592839215",
      priceUsd: "144.2702022096655295",
      changePercent24Hr: "-4.4391897971915994",
      vwap24Hr: "148.1052895141837986",
      explorer:
        "https://etherscan.io/token/0x4a220e6096b25eadb88358cb44068a3248254675",
    },
    {
      id: "vechain",
      rank: "35",
      symbol: "VET",
      name: "VeChain",
      supply: "72511146418.0000000000000000",
      maxSupply: "86712634466.0000000000000000",
      marketCapUsd: "1707884721.9501935936304196",
      volumeUsd24Hr: "23654105.6950933819450247",
      priceUsd: "0.0235534094593522",
      changePercent24Hr: "-3.7790677139736014",
      vwap24Hr: "0.0239636531894763",
      explorer: "https://explore.veforge.com/",
    },
    {
      id: "internet-computer",
      rank: "36",
      symbol: "ICP",
      name: "Internet Computer",
      supply: "284613043.2901898600000000",
      maxSupply: null,
      marketCapUsd: "1685057693.1776764962099276",
      volumeUsd24Hr: "22620073.7506047450533221",
      priceUsd: "5.9205216798852087",
      changePercent24Hr: "-2.5627433176095316",
      vwap24Hr: "6.0825386780394213",
      explorer: "https://www.dfinityexplorer.org/#/",
    },
    {
      id: "decentraland",
      rank: "37",
      symbol: "MANA",
      name: "Decentraland",
      supply: "1855084191.7804768000000000",
      maxSupply: null,
      marketCapUsd: "1397928138.8408515319928783",
      volumeUsd24Hr: "124001644.5982840617120119",
      priceUsd: "0.7535658732012292",
      changePercent24Hr: "-4.9939991528510985",
      vwap24Hr: "0.7849436928823438",
      explorer: "https://etherscan.io/token/decentraland",
    },
    {
      id: "fantom",
      rank: "38",
      symbol: "FTM",
      name: "Fantom",
      supply: "2772925438.4217800000000000",
      maxSupply: "3175000000.0000000000000000",
      marketCapUsd: "1364632902.1626863781549304",
      volumeUsd24Hr: "139691296.3744631376878640",
      priceUsd: "0.4921275138719099",
      changePercent24Hr: "3.9374766234902547",
      vwap24Hr: "0.4779363627480912",
      explorer:
        "https://etherscan.io/token/0x4e15361fd6b4bb609fa63c81a2be19d873717870",
    },
    {
      id: "bitcoin-bep2",
      rank: "39",
      symbol: "BTCB",
      name: "Bitcoin BEP2",
      supply: "52910.6194509800000000",
      maxSupply: null,
      marketCapUsd: "1225078142.9321558315587435",
      volumeUsd24Hr: "4033894105.0873930129019508",
      priceUsd: "23153.7289800046969051",
      changePercent24Hr: "-1.8812001868451490",
      vwap24Hr: "23513.8430295465648133",
      explorer: "https://explorer.binance.org/asset/BTCB-1DE",
    },
    {
      id: "aave",
      rank: "40",
      symbol: "AAVE",
      name: "Aave",
      supply: "14093192.5805645900000000",
      maxSupply: "16000000.0000000000000000",
      marketCapUsd: "1164819200.2008180670639042",
      volumeUsd24Hr: "41382683.0424626427974331",
      priceUsd: "82.6511944360412642",
      changePercent24Hr: "-5.1893852436518960",
      vwap24Hr: "85.4269830262853106",
      explorer:
        "https://etherscan.io/token/0x80fB784B7eD66730e8b1DBd9820aFD29931aab03",
    },
    {
      id: "eos",
      rank: "41",
      symbol: "EOS",
      name: "EOS",
      supply: "1081263745.2063000000000000",
      maxSupply: null,
      marketCapUsd: "1161967046.8282475144544701",
      volumeUsd24Hr: "50175843.6747928194266383",
      priceUsd: "1.0746379428513528",
      changePercent24Hr: "-2.6512526667402414",
      vwap24Hr: "1.0972764673338451",
      explorer: "https://bloks.io/",
    },
    {
      id: "axie-infinity",
      rank: "42",
      symbol: "AXS",
      name: "Axie Infinity",
      supply: "101043121.1955569700000000",
      maxSupply: "270000000.0000000000000000",
      marketCapUsd: "1136112650.0680712287847000",
      volumeUsd24Hr: "61747589.2507811052979211",
      priceUsd: "11.2438396263438856",
      changePercent24Hr: "-5.3885374615478114",
      vwap24Hr: "11.8117949237303784",
      explorer:
        "https://etherscan.io/token/0xf5d669627376ebd411e34b98f19c868c8aba5ada",
    },
    {
      id: "the-sandbox",
      rank: "43",
      symbol: "SAND",
      name: "The Sandbox",
      supply: "1499470108.2233226000000000",
      maxSupply: "3000000000.0000000000000000",
      marketCapUsd: "1107949753.4511453026290861",
      volumeUsd24Hr: "56491194.7621371062987661",
      priceUsd: "0.7388941916047409",
      changePercent24Hr: "-6.0481751383586826",
      vwap24Hr: "0.7749086354999904",
      explorer:
        "https://etherscan.io/token/0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
    },
    {
      id: "flow",
      rank: "44",
      symbol: "FLOW",
      name: "Flow",
      supply: "1036200000.0000000000000000",
      maxSupply: null,
      marketCapUsd: "1064888104.3902126993000000",
      volumeUsd24Hr: "18110378.1889831342763089",
      priceUsd: "1.0276858756902265",
      changePercent24Hr: "-6.5097701260328395",
      vwap24Hr: "1.0711757179480857",
      explorer: "https://flowscan.org/",
    },
    {
      id: "elrond-egld",
      rank: "45",
      symbol: "EGLD",
      name: "MultiversX",
      supply: "24184559.1898415400000000",
      maxSupply: "31415926.0000000000000000",
      marketCapUsd: "1046236689.0444405844963521",
      volumeUsd24Hr: "10498684.4644551302061294",
      priceUsd: "43.2605234121406224",
      changePercent24Hr: "-4.5182413816247743",
      vwap24Hr: "44.4681011623204943",
      explorer: "https://explorer.elrond.com/",
    },
    {
      id: "theta",
      rank: "46",
      symbol: "THETA",
      name: "THETA",
      supply: "1000000000.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "1044659012.8356519000000000",
      volumeUsd24Hr: "14246892.1264882801559901",
      priceUsd: "1.0446590128356519",
      changePercent24Hr: "-6.0658928109587275",
      vwap24Hr: "1.0837800922393816",
      explorer: "https://explorer.thetatoken.org/",
    },
    {
      id: "tezos",
      rank: "47",
      symbol: "XTZ",
      name: "Tezos",
      supply: "925256713.5145480000000000",
      maxSupply: null,
      marketCapUsd: "1010516916.4577764030213669",
      volumeUsd24Hr: "14552696.6827779716907361",
      priceUsd: "1.0921476188152920",
      changePercent24Hr: "-5.6160295415752471",
      vwap24Hr: "1.1309951141521742",
      explorer: "https://tzkt.io/",
    },
    {
      id: "hedera-hashgraph",
      rank: "48",
      symbol: "HBAR",
      name: "Hedera Hashgraph",
      supply: "14832756028.0000000000000000",
      maxSupply: "50000000000.0000000000000000",
      marketCapUsd: "975698231.1969157617454336",
      volumeUsd24Hr: "13963804.7073124169155688",
      priceUsd: "0.0657799689656512",
      changePercent24Hr: "-4.6368374432982713",
      vwap24Hr: "0.0679614942826771",
      explorer: "https://hash-hash.info/",
    },
    {
      id: "trueusd",
      rank: "49",
      symbol: "TUSD",
      name: "TrueUSD",
      supply: "944066074.3110939000000000",
      maxSupply: null,
      marketCapUsd: "943808050.4475849647232795",
      volumeUsd24Hr: "11687416.0290984221210203",
      priceUsd: "0.9997266887662527",
      changePercent24Hr: "-0.1315598637918758",
      vwap24Hr: "0.9983208678262569",
      explorer:
        "https://etherscan.io/token/0x8dd5fbce2f6a956c3022ba3663759011dd51e73e",
    },
    {
      id: "chiliz",
      rank: "50",
      symbol: "CHZ",
      name: "Chiliz",
      supply: "6661610577.1075735000000000",
      maxSupply: "8888888888.0000000000000000",
      marketCapUsd: "908477836.0423812836660281",
      volumeUsd24Hr: "52128097.9113930233769800",
      priceUsd: "0.1363751041173644",
      changePercent24Hr: "-2.2274155454802425",
      vwap24Hr: "0.1401004515585208",
      explorer:
        "https://etherscan.io/token/0x3506424f91fd33084466f402d5d97f05f8e3b4af",
    },
    {
      id: "paxos-standard",
      rank: "51",
      symbol: "USDP",
      name: "Pax Dollar",
      supply: "878084065.0806830000000000",
      maxSupply: null,
      marketCapUsd: "852758888.5021621781122754",
      volumeUsd24Hr: "472295.0217938637086724",
      priceUsd: "0.9711585967840177",
      changePercent24Hr: "-0.8546282498857334",
      vwap24Hr: null,
      explorer:
        "https://etherscan.io/token/0x8e870d67f660d95d5be530380d0ec0bd388289e1",
    },
    {
      id: "huobi-token",
      rank: "52",
      symbol: "HT",
      name: "Huobi Token",
      supply: "162233844.0000000000000000",
      maxSupply: "500000000.0000000000000000",
      marketCapUsd: "828807648.9917110367450040",
      volumeUsd24Hr: "7565786.9150241639077217",
      priceUsd: "5.1087222527483910",
      changePercent24Hr: "-0.8023637242924890",
      vwap24Hr: "5.1191534678154317",
      explorer:
        "https://etherscan.io/token/0x6f259637dcd74c767781e37bc6133cd6a68aa161",
    },
    {
      id: "bitcoin-sv",
      rank: "53",
      symbol: "BSV",
      name: "Bitcoin SV",
      supply: "19266076.6442390500000000",
      maxSupply: "21000000.0000000000000000",
      marketCapUsd: "827395131.5039976707570010",
      volumeUsd24Hr: "8970723.2714383357716522",
      priceUsd: "42.9456991572493145",
      changePercent24Hr: "-2.2597575333466527",
      vwap24Hr: "43.5810801178182112",
      explorer: "https://bsvexplorer.io/",
    },
    {
      id: "kucoin-token",
      rank: "54",
      symbol: "KCS",
      name: "KuCoin Token",
      supply: "98379860.9500000000000000",
      maxSupply: "170118638.0000000000000000",
      marketCapUsd: "817687173.0194820124456410",
      volumeUsd24Hr: "1413743.8818611626498400",
      priceUsd: "8.3115300745856768",
      changePercent24Hr: "-0.2976384657119787",
      vwap24Hr: "8.3196810512613982",
      explorer:
        "https://etherscan.io/token/0xf34960d9d60be18cc1d5afc1a6f012a723a28811",
    },
    {
      id: "the-graph",
      rank: "55",
      symbol: "GRT",
      name: "The Graph",
      supply: "8771515970.0149380000000000",
      maxSupply: "0.0000000000000000",
      marketCapUsd: "786255372.8844837041221311",
      volumeUsd24Hr: "21240003.0002662824635311",
      priceUsd: "0.0896373415464630",
      changePercent24Hr: "-6.5379244926277960",
      vwap24Hr: "0.0925894186695588",
      explorer:
        "https://etherscan.io/token/0xc944e90c64b2c07662a292be6244bdf05cda44a7",
    },
    {
      id: "frax-share",
      rank: "56",
      symbol: "FXS",
      name: "Frax Share",
      supply: "73280323.0985028900000000",
      maxSupply: null,
      marketCapUsd: "751233871.5346297254667672",
      volumeUsd24Hr: "3028813.0445348112010176",
      priceUsd: "10.2515087239015921",
      changePercent24Hr: "-7.3876196499223773",
      vwap24Hr: "10.7312080243788808",
      explorer:
        "https://etherscan.io/token/0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
    },
    {
      id: "zcash",
      rank: "57",
      symbol: "ZEC",
      name: "Zcash",
      supply: "16251412.5000000000000000",
      maxSupply: "21000000.0000000000000000",
      marketCapUsd: "744799342.0197258755241413",
      volumeUsd24Hr: "63812921.3532386829413316",
      priceUsd: "45.8298219936098401",
      changePercent24Hr: "-4.4108887157545530",
      vwap24Hr: "46.2828405653265925",
      explorer: "https://explorer.zcha.in/",
    },
    {
      id: "curve-dao-token",
      rank: "58",
      symbol: "CRV",
      name: "Curve DAO Token",
      supply: "703945198.4123597000000000",
      maxSupply: "3303030299.0000000000000000",
      marketCapUsd: "724330063.4384160624109989",
      volumeUsd24Hr: "15756511.1430780553253650",
      priceUsd: "1.0289580283692982",
      changePercent24Hr: "-5.3275086968260247",
      vwap24Hr: "1.0700658779057084",
      explorer:
        "https://etherscan.io/token/0xD533a949740bb3306d119CC777fa900bA034cd52",
    },
    {
      id: "trust-wallet-token",
      rank: "59",
      symbol: "TWT",
      name: "Trust Wallet Token",
      supply: "416649900.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "717875908.4195644815879000",
      volumeUsd24Hr: "36338927.7305291766707956",
      priceUsd: "1.7229715125806210",
      changePercent24Hr: "-6.1574279036241861",
      vwap24Hr: "1.7224527886049908",
      explorer: "https://explorer.binance.org/asset/TWT-8C2",
    },
    {
      id: "ecash",
      rank: "60",
      symbol: "XEC",
      name: "eCash",
      supply: "19294385923303.0000000000000000",
      maxSupply: "21000000000000.0000000000000000",
      marketCapUsd: "679727569.4655818739686177",
      volumeUsd24Hr: "2961169.3518462328347571",
      priceUsd: "0.0000352292927159",
      changePercent24Hr: "-5.5396997268168704",
      vwap24Hr: "0.0000366140224299",
      explorer: "https://explorer.bitcoinabc.org/",
    },
    {
      id: "pancakeswap",
      rank: "61",
      symbol: "CAKE",
      name: "PancakeSwap",
      supply: "165419108.3116932800000000",
      maxSupply: "750000000.0000000000000000",
      marketCapUsd: "666069618.0126855399189805",
      volumeUsd24Hr: "12537947.9640236384356007",
      priceUsd: "4.0265579038041633",
      changePercent24Hr: "-2.2304687067054397",
      vwap24Hr: "4.0723226551855796",
      explorer:
        "https://bscscan.com/token/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
    },
    {
      id: "dash",
      rank: "62",
      symbol: "DASH",
      name: "Dash",
      supply: "11120724.8141110200000000",
      maxSupply: "18900000.0000000000000000",
      marketCapUsd: "663927482.5124031096830314",
      volumeUsd24Hr: "82502708.8820006130442978",
      priceUsd: "59.7018174273991179",
      changePercent24Hr: "3.5918365868795261",
      vwap24Hr: "58.2089532876491640",
      explorer: "https://explorer.dash.org",
    },
    {
      id: "mina",
      rank: "63",
      symbol: "MINA",
      name: "Mina",
      supply: "822819065.8400393000000000",
      maxSupply: null,
      marketCapUsd: "649748016.3004298395019716",
      volumeUsd24Hr: "107963728.1140615083486177",
      priceUsd: "0.7896608662526356",
      changePercent24Hr: "10.8929602308301697",
      vwap24Hr: "0.8186907410189474",
      explorer: "https://minaexplorer.com/",
    },
    {
      id: "ftx-token",
      rank: "64",
      symbol: "FTT",
      name: "FTX Token",
      supply: "328895112.3043850000000000",
      maxSupply: "352170015.0000000000000000",
      marketCapUsd: "649628754.5181393286994024",
      volumeUsd24Hr: "4174900.0919199289270697",
      priceUsd: "1.9751851888784610",
      changePercent24Hr: "-1.9444711193638131",
      vwap24Hr: "2.0364281131047155",
      explorer:
        "https://etherscan.io/token/0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
    },
    {
      id: "kava",
      rank: "65",
      symbol: "KAVA",
      name: "Kava",
      supply: "394393268.0000000000000000",
      maxSupply: null,
      marketCapUsd: "641825257.1211266849189568",
      volumeUsd24Hr: "10638382.4719117352107507",
      priceUsd: "1.6273737642020976",
      changePercent24Hr: "-6.4603781366968012",
      vwap24Hr: "1.1965071979152797",
      explorer: "https://www.mintscan.io/kava",
    },
    {
      id: "maker",
      rank: "66",
      symbol: "MKR",
      name: "Maker",
      supply: "977631.0369508900000000",
      maxSupply: "1005577.0000000000000000",
      marketCapUsd: "640711258.1111031622811223",
      volumeUsd24Hr: "9074076.4306457054162762",
      priceUsd: "655.3712330056563492",
      changePercent24Hr: "-2.3690836251651856",
      vwap24Hr: "662.8538493552025430",
      explorer: "https://etherscan.io/token/Maker",
    },
    {
      id: "klaytn",
      rank: "67",
      symbol: "KLAY",
      name: "Klaytn",
      supply: "3088989756.3606810000000000",
      maxSupply: null,
      marketCapUsd: "640401434.9427062113042105",
      volumeUsd24Hr: "7741325.1586022695517330",
      priceUsd: "0.2073174356192105",
      changePercent24Hr: "-3.6092177796662391",
      vwap24Hr: "0.2112819472403512",
      explorer: "https://scope.klaytn.com/blocks",
    },
    {
      id: "iota",
      rank: "68",
      symbol: "MIOTA",
      name: "IOTA",
      supply: "2779530283.0000000000000000",
      maxSupply: "2779530283.0000000000000000",
      marketCapUsd: "636258579.5652750310836997",
      volumeUsd24Hr: "3933841.7025928282916772",
      priceUsd: "0.2289086697334159",
      changePercent24Hr: "-4.7961684135277709",
      vwap24Hr: "0.2351621986713486",
      explorer: "https://thetangle.org/",
    },
    {
      id: "thorchain",
      rank: "69",
      symbol: "RUNE",
      name: "THORChain",
      supply: "327056566.0000000000000000",
      maxSupply: "500000000.0000000000000000",
      marketCapUsd: "592430177.1848338548737726",
      volumeUsd24Hr: "18023699.0065069489849743",
      priceUsd: "1.8113997356189261",
      changePercent24Hr: "-4.9899407944329307",
      vwap24Hr: "1.8676189718806121",
      explorer: "https://explorer.binance.org/asset/RUNE-B1A",
    },
    {
      id: "neo",
      rank: "70",
      symbol: "NEO",
      name: "Neo",
      supply: "70538831.0000000000000000",
      maxSupply: "100000000.0000000000000000",
      marketCapUsd: "586537988.9555029320492070",
      volumeUsd24Hr: "14530157.8372888409473089",
      priceUsd: "8.3151078723646970",
      changePercent24Hr: "-1.8648248382356050",
      vwap24Hr: "8.2739355061274620",
      explorer: "https://neotracker.io",
    },
    {
      id: "synthetix-network-token",
      rank: "71",
      symbol: "SNX",
      name: "Synthetix",
      supply: "233716733.4900000000000000",
      maxSupply: "212424133.0000000000000000",
      marketCapUsd: "538611839.0847737700872309",
      volumeUsd24Hr: "12627437.7354282323011247",
      priceUsd: "2.3045497472170484",
      changePercent24Hr: "-5.9020550380278516",
      vwap24Hr: "2.4056097188690835",
      explorer:
        "https://etherscan.io/token/0xc011a72400e58ecd99ee497cf89e3775d4bd732f",
    },
    {
      id: "gatetoken",
      rank: "72",
      symbol: "GT",
      name: "GateToken",
      supply: "108265076.6284058700000000",
      maxSupply: null,
      marketCapUsd: "472564339.1135872329261696",
      volumeUsd24Hr: "849962.7677649205252194",
      priceUsd: "4.3648825071777481",
      changePercent24Hr: "1.6919927692769634",
      vwap24Hr: "4.3950295678848441",
      explorer: null,
    },
    {
      id: "nexo",
      rank: "73",
      symbol: "NEXO",
      name: "Nexo",
      supply: "560000011.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "462088800.5220323976753055",
      volumeUsd24Hr: "856520.6021378946520511",
      priceUsd: "0.8251585561523005",
      changePercent24Hr: "-2.9734206884838115",
      vwap24Hr: "0.8435025113987552",
      explorer:
        "https://etherscan.io/token/0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
    },
    {
      id: "enjin-coin",
      rank: "74",
      symbol: "ENJ",
      name: "Enjin Coin",
      supply: "1000000000.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "440028493.6518212000000000",
      volumeUsd24Hr: "12862333.6390524008904924",
      priceUsd: "0.4400284936518212",
      changePercent24Hr: "-6.8071346409540936",
      vwap24Hr: "0.4592322215687768",
      explorer:
        "https://etherscan.io/token/0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
    },
    {
      id: "convex-finance",
      rank: "75",
      symbol: "CVX",
      name: "Convex Finance",
      supply: "74094162.6138798600000000",
      maxSupply: "100000000.0000000000000000",
      marketCapUsd: "439411914.0374062670487041",
      volumeUsd24Hr: "476239.7429830900562487",
      priceUsd: "5.9304525287271742",
      changePercent24Hr: "-3.2094581084041427",
      vwap24Hr: "6.1258714197828227",
      explorer:
        "https://etherscan.io/token/0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
    },
    {
      id: "zilliqa",
      rank: "76",
      symbol: "ZIL",
      name: "Zilliqa",
      supply: "15867699446.7699000000000000",
      maxSupply: "21000000000.0000000000000000",
      marketCapUsd: "435471824.4167886255300673",
      volumeUsd24Hr: "20688037.7047907529280803",
      priceUsd: "0.0274439168625314",
      changePercent24Hr: "-6.7218251813106064",
      vwap24Hr: "0.0285907761803133",
      explorer:
        "https://etherscan.io/token/0x05f4a42e251f2d52b8ed15e9fedaacfcef1fad27",
    },
    {
      id: "loopring",
      rank: "77",
      symbol: "LRC",
      name: "Loopring",
      supply: "1330133545.5263836000000000",
      maxSupply: "1374513896.0000000000000000",
      marketCapUsd: "435383109.6817108145223940",
      volumeUsd24Hr: "57403236.2444895779820362",
      priceUsd: "0.3273228550216087",
      changePercent24Hr: "2.2219715638696178",
      vwap24Hr: "0.3385553743234703",
      explorer:
        "https://etherscan.io/token/0xEF68e7C694F40c8202821eDF525dE3782458639f",
    },
    {
      id: "fei-protocol",
      rank: "78",
      symbol: "FEI",
      name: "Fei Protocol",
      supply: "424996177.7889055600000000",
      maxSupply: null,
      marketCapUsd: "416915081.1356279773517920",
      volumeUsd24Hr: "732337.5938484664747092",
      priceUsd: "0.9809854839275956",
      changePercent24Hr: "-0.0609376158749292",
      vwap24Hr: "0.9739302332025694",
      explorer:
        "https://etherscan.io/token/0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
    },
    {
      id: "1inch",
      rank: "79",
      symbol: "1INCH",
      name: "1inch Network",
      supply: "797317460.9391139000000000",
      maxSupply: null,
      marketCapUsd: "410678381.6151998311317280",
      volumeUsd24Hr: "12758304.3990980841940899",
      priceUsd: "0.5150751134077581",
      changePercent24Hr: "-4.1383660649683050",
      vwap24Hr: "0.5262834631259197",
      explorer:
        "https://etherscan.io/token/0x111111111117dc0aa78b770fa6a738034120c302",
    },
    {
      id: "dydx",
      rank: "80",
      symbol: "DYDX",
      name: "dYdX",
      supply: "156256174.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "402561927.9610799479542926",
      volumeUsd24Hr: "134118780.9155662858844119",
      priceUsd: "2.5762945402789649",
      changePercent24Hr: "16.7594077183910203",
      vwap24Hr: "2.3833006633960738",
      explorer: null,
    },
    {
      id: "rocket-pool",
      rank: "81",
      symbol: "RPL",
      name: "Rocket Pool",
      supply: "10279742.4041810000000000",
      maxSupply: "18970871.0000000000000000",
      marketCapUsd: "397734585.7445215872858011",
      volumeUsd24Hr: "269658.5336040077884964",
      priceUsd: "38.6911043201582639",
      changePercent24Hr: "-0.8172181663191403",
      vwap24Hr: "39.7128743422838022",
      explorer:
        "https://etherscan.io/token/0xb4efd85c19999d84251304bda99e90b92300bd93",
    },
    {
      id: "casper",
      rank: "82",
      symbol: "CSPR",
      name: "Casper",
      supply: "10714921229.0000000000000000",
      maxSupply: null,
      marketCapUsd: "391057990.7252256535261273",
      volumeUsd24Hr: "1832328.9009612987651045",
      priceUsd: "0.0364965810170237",
      changePercent24Hr: "-0.7436580630133672",
      vwap24Hr: "0.0365246541972775",
      explorer: "https://casperstats.io/",
    },
    {
      id: "gala",
      rank: "83",
      symbol: "GALA",
      name: "Gala",
      supply: "6977205436.0000000000000000",
      maxSupply: null,
      marketCapUsd: "387765400.5882018042857868",
      volumeUsd24Hr: "130408955.0897512718867508",
      priceUsd: "0.0555760331475213",
      changePercent24Hr: "-6.2789891524762098",
      vwap24Hr: "0.0579546289625604",
      explorer:
        "https://ethplorer.io/es/address/0x15d4c048f83bd7e37d49ea4c83a07267ec4203da#chart=candlestick",
    },
    {
      id: "compound",
      rank: "84",
      symbol: "COMP",
      name: "Compound",
      supply: "7267151.9985256900000000",
      maxSupply: "10000000.0000000000000000",
      marketCapUsd: "387636026.7579045726469867",
      volumeUsd24Hr: "14301719.6206633485674730",
      priceUsd: "53.3408447816346092",
      changePercent24Hr: "-5.7430759188798924",
      vwap24Hr: "55.5194686460539140",
      explorer:
        "https://etherscan.io/token/0xc00e94cb662c3520282e6f5717214004a7f26888",
    },
    {
      id: "helium",
      rank: "85",
      symbol: "HNT",
      name: "Helium",
      supply: "137270130.2673820300000000",
      maxSupply: "223000000.0000000000000000",
      marketCapUsd: "378778295.7772260328952994",
      volumeUsd24Hr: "951745.5792180987781198",
      priceUsd: "2.7593642917029481",
      changePercent24Hr: "-5.9069915511826836",
      vwap24Hr: "2.8690348457192852",
      explorer: "https://explorer.helium.com/",
    },
    {
      id: "stacks",
      rank: "86",
      symbol: "STX",
      name: "Stacks",
      supply: "1358408768.3946650000000000",
      maxSupply: "1818000000.0000000000000000",
      marketCapUsd: "377673468.7049227811371587",
      volumeUsd24Hr: "1156558.9664750045576515",
      priceUsd: "0.2780263772525911",
      changePercent24Hr: "-4.8366396450751411",
      vwap24Hr: "0.2850893403391452",
      explorer: "https://explorer.xinfin.network/",
    },
    {
      id: "basic-attention-token",
      rank: "87",
      symbol: "BAT",
      name: "Basic Attention Token",
      supply: "1490121294.4163349000000000",
      maxSupply: "1500000000.0000000000000000",
      marketCapUsd: "376754057.3808836100026524",
      volumeUsd24Hr: "9951196.7021158304336334",
      priceUsd: "0.2528344899120808",
      changePercent24Hr: "-6.8757691615862052",
      vwap24Hr: "0.2641491161562770",
      explorer: "https://etherscan.io/token/Bat",
    },
    {
      id: "holo",
      rank: "88",
      symbol: "HOT",
      name: "Holo",
      supply: "173342974126.7371200000000000",
      maxSupply: null,
      marketCapUsd: "368240180.4545183107119679",
      volumeUsd24Hr: "4032877.9686063005311961",
      priceUsd: "0.0021243444235893",
      changePercent24Hr: "-3.9791533730452815",
      vwap24Hr: "0.0021557078627612",
      explorer:
        "https://etherscan.io/token/0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
    },
    {
      id: "celo",
      rank: "89",
      symbol: "CELO",
      name: "Celo",
      supply: "483246415.0000000000000000",
      maxSupply: "1000000000.0000000000000000",
      marketCapUsd: "355618566.4226697804592935",
      volumeUsd24Hr: "5199677.2095788239862264",
      priceUsd: "0.7358948879582889",
      changePercent24Hr: "-5.2462750387811620",
      vwap24Hr: "0.7641202006531021",
      explorer: "https://explorer.celo.org/blocks",
    },
    {
      id: "ravencoin",
      rank: "90",
      symbol: "RVN",
      name: "Ravencoin",
      supply: "12156804605.2803300000000000",
      maxSupply: "21000000000.0000000000000000",
      marketCapUsd: "352759442.2631214931739541",
      volumeUsd24Hr: "5415289.8382017848339189",
      priceUsd: "0.0290174477353942",
      changePercent24Hr: "-4.1049299663899107",
      vwap24Hr: "0.0299021622220104",
      explorer: "https://ravencoin.network/",
    },
    {
      id: "xinfin-network",
      rank: "91",
      symbol: "XDC",
      name: "XinFin Network",
      supply: "12293293518.5500000000000000",
      maxSupply: null,
      marketCapUsd: "343889515.9592838723148415",
      volumeUsd24Hr: "1300761.9575638293608918",
      priceUsd: "0.0279737497067300",
      changePercent24Hr: "-0.4089066745714650",
      vwap24Hr: "0.0297852350676299",
      explorer:
        "https://etherscan.io/token/0x41ab1b6fcbb2fa9dced81acbdec13ea6315f2bf2",
    },
    {
      id: "arweave",
      rank: "92",
      symbol: "AR",
      name: "Arweave",
      supply: "33394701.0000000000000000",
      maxSupply: "66000000.0000000000000000",
      marketCapUsd: "342408116.2911266485710561",
      volumeUsd24Hr: "18587258.2879844142893275",
      priceUsd: "10.2533667329773861",
      changePercent24Hr: "-4.5229573465918164",
      vwap24Hr: "10.6800678989202440",
      explorer: "https://viewblock.io/arweave",
    },
    {
      id: "decred",
      rank: "93",
      symbol: "DCR",
      name: "Decred",
      supply: "14697599.6252421500000000",
      maxSupply: "21000000.0000000000000000",
      marketCapUsd: "339980953.4641998922626503",
      volumeUsd24Hr: "712370.3273201611368004",
      priceUsd: "23.1317332171918204",
      changePercent24Hr: "-4.0551949916530703",
      vwap24Hr: "23.4190798114699711",
      explorer: "https://mainnet.decred.org/",
    },
    {
      id: "nem",
      rank: "94",
      symbol: "XEM",
      name: "NEM",
      supply: "8999999999.0000000000000000",
      maxSupply: "8999999999.0000000000000000",
      marketCapUsd: "337765834.0304500628813356",
      volumeUsd24Hr: "7567215.2456037852182137",
      priceUsd: "0.0375295371186644",
      changePercent24Hr: "-4.7469717126909087",
      vwap24Hr: "0.0389970459384917",
      explorer: "http://nembex.nem.ninja/",
    },
    {
      id: "theta-fuel",
      rank: "95",
      symbol: "TFUEL",
      name: "Theta Fuel",
      supply: "6012963826.0000000000000000",
      maxSupply: null,
      marketCapUsd: "317878071.3773785736314656",
      volumeUsd24Hr: "2627161.4700974248716304",
      priceUsd: "0.0528654554685456",
      changePercent24Hr: "-5.9362623392579893",
      vwap24Hr: "0.0546891466072985",
      explorer: "https://explorer.thetatoken.org/",
    },
    {
      id: "balancer",
      rank: "96",
      symbol: "BAL",
      name: "Balancer",
      supply: "46823900.1925372400000000",
      maxSupply: "96150704.0000000000000000",
      marketCapUsd: "316787322.3916319037208949",
      volumeUsd24Hr: "6659627.9030127890036146",
      priceUsd: "6.7655048188856605",
      changePercent24Hr: "-3.1450038989995321",
      vwap24Hr: "6.9435725861569914",
      explorer:
        "https://etherscan.io/token/0xba100000625a3754423978a60c9317c58a424e3D",
    },
    {
      id: "render-token",
      rank: "97",
      symbol: "RNDR",
      name: "Render Token",
      supply: "253798859.6938469700000000",
      maxSupply: "536870912.0000000000000000",
      marketCapUsd: "313720391.0133959476692038",
      volumeUsd24Hr: "29859073.6543595706796591",
      priceUsd: "1.2360985049019970",
      changePercent24Hr: "-8.3442352793981918",
      vwap24Hr: "1.2689615692841100",
      explorer:
        "https://etherscan.io/token/0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
    },
    {
      id: "oasis-network",
      rank: "98",
      symbol: "ROSE",
      name: "Oasis Network",
      supply: "5725718533.0000000000000000",
      maxSupply: "10000000000.0000000000000000",
      marketCapUsd: "309363738.4122805821355745",
      volumeUsd24Hr: "12417777.7708966296287431",
      priceUsd: "0.0540305529566765",
      changePercent24Hr: "-6.9731239868160682",
      vwap24Hr: "0.0567771615866925",
      explorer: "https://www.oasisscan.com/",
    },
    {
      id: "bitcoin-gold",
      rank: "99",
      symbol: "BTG",
      name: "Bitcoin Gold",
      supply: "17513923.5890000000000000",
      maxSupply: "21000000.0000000000000000",
      marketCapUsd: "307076587.0652196404299974",
      volumeUsd24Hr: "418022.9254675847481788",
      priceUsd: "17.5332834761301436",
      changePercent24Hr: "-3.3536207552502349",
      vwap24Hr: "18.1429682774935963",
      explorer: "https://explorer.bitcoingold.org/insight/",
    },
    {
      id: "defichain",
      rank: "100",
      symbol: "DFI",
      name: "DeFiChain",
      supply: "510738160.8525277400000000",
      maxSupply: "1200000000.0000000000000000",
      marketCapUsd: "299436725.4445794418089604",
      volumeUsd24Hr: "615892.9227337086108719",
      priceUsd: "0.5862822643695892",
      changePercent24Hr: "-2.7169884983402084",
      vwap24Hr: "0.6083514053802054",
      explorer: "http://explorer.defichain.io/",
    },
  ],
  timestamp: 1675097483350,
};
